"use client";

import { GalleryOptionsQuery } from "@/types/wordpressQueries";
import GalleryList from "./GalleryList";
import { useContext, useEffect } from "react";
import { LanguageContext } from "@/context/languageContext";
import { useLanguageUrl } from "@/context/languageURLContext";

interface GalleryComponentProps {
  data: GalleryOptionsQuery;
}

export default function GalleryComponent({ data }: GalleryComponentProps) {
  const { language } = useContext(LanguageContext);
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(`/${language === "en" ? "de" : "en"}/gallery`);
  }, [language, setUrl]);

  return (
    <section className="content">
      <div className="contentContainer">
        <GalleryList
          images={
            language === "en"
              ? data.galleryOptions.optionsGallery.images
              : data.galleryOptionsDE.optionsGallery.images
          }
        />
      </div>
    </section>
  );
}
